<template>
  <div>
    <v-container>
      <div class="text-h5 text-center ma-3">
        Evaluaciones de Desempeño
      </div>

      <!-- Botón para crear nueva valoración -->
      <v-row>
        <v-col>
          <v-btn color="primary" @click="showCreateDialog = true">
            Nueva Evaluacion
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mb-3" align="center">

        <!-- kram filtros de tienda y empleado -->
        <v-col cols="12" sm="12" md="6" lg="6" xl="5">
          <v-autocomplete v-model="filtros.tiendaSeleccionada" :items="tiendas" item-text="DirNom" item-value="DirId"
            label="Tienda" :multiple="false" @change="onTiendaChange" clearable dense outlined>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="4">
          <v-autocomplete v-model="filtros.empleadoSeleccionado" :items="empleados" item-text="PerNom"
            item-value="PerId" label="Empleado" clearable dense outlined :multiple="false" @change="onEmpleadoChange" />

        </v-col>
      </v-row>

      <!-- Tabla de valoraciones -->
      <v-data-table :headers="headers" :items="dataRows" :item-class="selectedRow" :options.sync="options"
        :footer-props="{ itemsPerPageOptions: [15, 30, 50, 100], disablePagination: loading, disableItemsPerPage: loading }"
        :server-items-length="totalDataRows" :loading="loading" @click:row="onClickRow" style="overflow: scroll"
        mobile-breakpoint="0" class="elevation-1" dense>
        <template v-slot:item.FechaValoracion="{ item }">
          {{ formatDate(item.FechaValoracion) }}
        </template>
        <template v-slot:item.TipoValoracion="{ item }">
          {{ item.TipoValoracion == 'AV' ? 'Empleado' : 'Responsable' }}
        </template>
        <template v-slot:item.Respondida="{ item }">
          <v-chip small :color="item.Respondida ? 'green' : 'orange'" dark>
            {{ item.Respondida ? 'Respondida' : 'Pendiente' }}
          </v-chip>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-btn small icon color="primary" :disabled="item.Respondida" @click.stop="onClickRow(item)"
            title="Editar respuestas">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn small icon color="indigo" v-if="item.Respondida" @click.stop="verPdf(item)" title="Ver PDF">
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Snackbar -->
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top timeout="2500">
        {{ snackbar.text }}
      </v-snackbar>

      <!-- Popup Crear Nueva Valoración -->
      <v-dialog v-model="showCreateDialog" max-width="600px">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Nueva Evaluacion
          </v-card-title>

          <v-card-text>
            <br>
            <!-- kram valoracion tipos permitidos -->
            <v-select v-model="newValoracion.tipo" :items="tiposPermitidos" item-text="text" item-value="value"
              label="Tipo de Evaluacion" outlined dense />

            <v-autocomplete v-model="newValoracion.trabajador" :items="empleados" item-text="PerNom" item-value="PerId"
              label="Empleado a Evaluar" clearable dense outlined>
            </v-autocomplete>


            <v-autocomplete v-model="newValoracion.tienda" :items="tiendas" item-text="DirNom" item-value="DirId"
              label="Tienda del empleado" clearable dense outlined>
            </v-autocomplete>


          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="crearValoracion">
              Crear
            </v-btn>
            <v-btn @click="showCreateDialog = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import funcs from "../funcs";



export default {

  computed: {
    ...mapState(['empId', 'perId', 'urlRaiz'])
  },
  data() {
    return {
      loading: true,
      showCreateDialog: false,
      totalDataRows: 0,
      dataRows: [],
      options: { itemsPerPage: 15 },

      filtros: {
        dir: null,
        per: null,
        empleadoSeleccionado: null,
        tiendaSeleccionada: null,
      },
      empleados: [],
      tiendas: [],

      headers: [
        { text: 'Fecha', value: 'FechaValoracion', sortable: false },
        { text: 'Tipo', value: 'TipoValoracion', sortable: false },
        { text: 'Empleado', value: 'EmpleadoNom', sortable: false },
        { text: 'Responsable', value: 'ResponsableNom', sortable: false },
        { text: 'Tienda', value: 'TiendaNom', sortable: false },
        { text: 'Estado', value: 'Respondida', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false }
      ],
      snackbar: { visible: false, color: '', text: '' },

      tiposPermitidos: [],

      newValoracion: {
        tipo: 'AV',
        perIdValoracion: null,
        trabajador: null,   // tabajadorFiltro kram
        dirId: null,
        tienda: null,       // TiendaFiltro kram
        observacionesValorador: null,
        observacionesTrabajador: null
      }
    }
  },
  mounted() {
    this.loadData();
    this.loadEmpleadosTiendas();

  },
  watch: {
    options: {
      handler() { this.loadData(); },
      deep: true
    }
  },
  methods: {


    loadData() {
      this.loading = true;
      const AuthToken = localStorage.getItem('token');

      const page = this.options.page || 1;
      const pageSize = this.options.itemsPerPage || 15;
      //kram pasamos en el body
      const payload = {
        page: page,
        pageSize: pageSize,
        perId: this.perId,
        empleadoId: this.filtros.empleadoSeleccionado || null,//si ponemos empleado para filtrar lo manda kram
        tiendaId: this.filtros.tiendaSeleccionada || null, //si ponemos tienda para filtrar lo manda kram
        empId: this.empId
      };

      axios.post(`${this.urlRaiz}/api/valoracion/list`, payload, {
        headers: { Authorization: AuthToken }
      })
        .then(result => {
          this.dataRows = result.data.EntsList || [];
          this.totalDataRows = result.data.EntsTotCount || 0;
          //trae los tipos permitidos segun el usuario logeado
          this.tiposPermitidos = result.data.TiposPermitidos;
          const empIds = [8, 12, 15];

          this.tiposPermitidos = (result.data.TiposPermitidos).map(tipo => {
            if (empIds.includes(this.empId)) {
              // Para empId 8,12,15 mostramos texto bonito kram
              return {
                text: tipo === 'AV' ? 'ASESOR DE VENTAS / VENDEDOR/A' : tipo === 'RT' ? 'RT / RESPONSABLE TIENDA' : tipo,
                value: tipo
              };
            } else {
              // Para otros usuarios mostramos el valor original kram
              return { text: tipo, value: tipo };
            }
          });

           if (!this.newValoracion.tipo) {
            this.newValoracion.tipo = 'AV'; // Predeterminado a "AV"
          }

        })
        .catch(() => {
          this.mostrarSnackbar("Error al cargar valoraciones", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadEmpleadosTiendas() {
      this.loading = true;
      const AuthToken = localStorage.getItem('token');

      axios.get(`${this.urlRaiz}/api/valoracion/filtros/${this.perId}`, {
        headers: { Authorization: AuthToken }
      })
        .then(result => {
          this.empleados = result.data.empleados
          this.tiendas = result.data.tiendas


        })
        .catch(() => {
          this.mostrarSnackbar("Error al cargar empleados/tiendas", "error");
        })
        .finally(() => {
          this.loading = false;
        });

    },

    crearValoracion() {
      const AuthToken = localStorage.getItem('token');
      const payload = {
        PerIdValoracion: this.newValoracion.trabajador ? this.newValoracion.trabajador : null,
        PerIdSuperior: this.perId,  // el usuario logado
        DirId: this.newValoracion.tienda ? this.newValoracion.tienda : null,
        TipoValoracion: this.newValoracion.tipo,
        ObservacionesValorador: this.newValoracion.observacionesValorador,
        ObservacionesTrabajador: this.newValoracion.observacionesTrabajador,
        FechaValoracion: new Date()
      };

      if (!payload.PerIdValoracion || !payload.DirId) {
        this.mostrarSnackbar("Debes seleccionar empleado y tienda", "error");
        return;
      }

      axios.post(this.urlRaiz + "/api/valoracion/create", payload, {
        headers: { "Authorization": AuthToken }
      }).then(res => {
        this.showCreateDialog = false;
        this.mostrarSnackbar("Valoración creada correctamente");

        const id = res.data?.ValoracionId ?? res.data?.valoracionId;
        this.options.page = 1;
        // Redirigir a la pantalla de preguntas
        //console.log(res.data.valoracionId);
        this.$router.push('/valoracion-responder/' + id);
      }).catch(() => {
        this.mostrarSnackbar("Error al crear la valoración", "error");
      });
    },

    onClickRow(item) {

      if (!item || !item.ValoracionId) return;

      if (item.Respondida) {
        // O abre vista read-only
        this.mostrarSnackbar("Esta valoración ya está respondida", "error");
        return;
      }

      this.$router.push('/valoracion-responder/' + item.ValoracionId);
    },
    //kram 
    onEmpleadoChange() {
      this.options.page = 1;   // Reiniciar paginación
      this.loadData();         // Recargar lista filtrada
    },

    onTiendaChange() {
      this.options.page = 1;
      this.loadData();

    },

    selectedRow() {
      return '';
    },
    formatDate(value) {
      return funcs.formatDate(value, true);
    },

    mostrarSnackbar(texto, tipo = 'success') {
      this.snackbar.text = texto;
      this.snackbar.color = tipo === 'error' ? 'red darken-2' : 'green darken-2';
      this.snackbar.visible = true;
    },


    verPdf(item) {
      const AuthToken = localStorage.getItem('token');
      axios.get(`${this.urlRaiz}/api/valoracion-firma/pdf`, {
        headers: { Authorization: AuthToken },
        params: { valoracionId: item.ValoracionId },
        responseType: 'blob'
      })
        .then(res => {
          // crear URL temporal y abrir en pestaña
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          // abre en nueva pestaña
          window.open(url, '_blank');
        })
        .catch(() => {
          this.mostrarSnackbar("No se pudo abrir el PDF", "error");
        });
    },


  }
}
</script>
